import Component from './Role';
import enhancer from './Role.enhancer';

const Role = enhancer(Component);

export default Role;
